import adapter from './adapter';

export default Object.assign(Object.create(adapter), {
  /**
   * Возвращает термины, название которых содержит подстроку name.
   *
   * @param {Object} name
   * @returns {Promise<Array<ApiTermSearchListItem>>}
   */
  findTerms(name) {
    let params = { name: name };

    return this.getData('/terms', { params: params });
  },

  /**
   * Возвращает описание термина name.
   *
   * @param {string} name
   * @returns {Promise<ApiTermInfo>}
   */
  getTermInfo(name) {
    let params = { name: name };

    return this.getData('/terms/info', { params: params });
  }
});
